import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { TableRow, TableCell } from "./TableComponent.styles";
import Tooltip from "../Tooltip";

type SortableItemProps = {
  id: number;
  row: any;
  index: number;
  columns: any[];
  $compactUI?: boolean;
  onRowClick?: (row: any) => void;
  $isDragDisabled?: boolean;
  activeRow?: boolean;
};

export const SortableItem: React.FC<SortableItemProps> = ({
  id,
  row,
  index,
  columns,
  $compactUI,
  onRowClick,
  $isDragDisabled,
  activeRow,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <TableRow
      activeRow={activeRow}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...(!$isDragDisabled ? listeners : {})}
      onClick={(e) => {
        e.stopPropagation();
        onRowClick?.(row);
      }}
    >
      {columns.map(
        (column, colIndex) =>
          !column.hidden && (
            <TableCell
              key={column.accessor + colIndex}
              $index={colIndex}
              $compactUI={$compactUI}
              style={{
                width: column.width || "auto",
                minWidth: column.minWidth || "auto",
                maxWidth: column.maxWidth || "auto",
              }}
            >
              {column.accessor === "display_row_index" ? (
                index + 1
              ) : column.Cell ? (
                column.Cell({
                  value: row[column.accessor],
                  row,
                })
              ) : (
                <Tooltip content={row[column.accessor]}>
                  {row[column.accessor]}
                </Tooltip>
              )}
            </TableCell>
          )
      )}
    </TableRow>
  );
};
